export default __webpack_public_path__ + "static/image-2-154722ba615adc5eb91827a46e789af6.jpg";